import Axios from "axios";
import React, { useContext } from "react";
import { configContext } from "../config-provider";
import { Spin } from "../loading";
import { BarChart } from "../bar-chart";
import { LineChart } from "../line-chart";
import { latestMonth } from "../../utils";

/**
 * The bar chart under "Latest Month" counts PROG_DATE across the month two
 * months back — see `countLastMonth()` in the server's programme.service.ts.
 */
const BAR_CHART_MONTHS_AGO = 2;

interface ProgrammeOverviewProps {}

interface State {
  lineChart: unknown[];
  pieChart: unknown[];
  barChart: unknown[];
  loading: boolean;
}

export const ProgrammeOverview: React.FC<ProgrammeOverviewProps> = (props) => {
  const { dataStartMonth } = useContext(configContext);
  const [state, setState] = React.useState<State>({
    lineChart: [],
    pieChart: [],
    barChart: [],
    loading: false,
  });

  React.useEffect(() => {
    setState({ ...state, loading: true });
    Axios.get(`/programme/overview`, { params: { from: dataStartMonth } })
      .then((res) => {
        const { lineChart, barChart } = res.data;
        setState({
          ...state,
          lineChart: [{ label: "Programme", data: lineChart[0] }],
          barChart: [{ label: "Programme", data: barChart[0] }],
        });
      })
      .finally(() => {
        setState((prev) => ({ ...prev, loading: false }));
      });
  // eslint-disable-next-line
  }, []);

  return (
    <div className="overview">
      <span className="title">programme overview</span>

      <div className="contract">
        {/* <span className="title">This Contract</span> */}
        <Spin spin={state.loading}>
          <LineChart data={state.lineChart} />
        </Spin>
      </div>

      <div>
        <span className="title">
          Latest Month <span className="month">&mdash; {latestMonth(BAR_CHART_MONTHS_AGO)}</span>
        </span>
        <div className="latest">
          <Spin spin={state.loading}>
            <BarChart data={state.barChart} />
          </Spin>
        </div>
      </div>
    </div>
  );
};
